import { type ApiConfig, type Environment, SearchApi } from '@pkgs/api';
import { datadogRum } from '@datadog/browser-rum';

export const SEARCH_API_CONFIG = {
  applicationKey: process.env.NEXT_PUBLIC_APPLICATION_KEY_FRONTEND!,
  environment: (process.env.NEXT_PUBLIC_BFF_ENV ?? 'prod') as Environment,
  ...(process.env.NEXT_PUBLIC_USE_BFF_PROXY === 'true' && {
    baseURL: `${process.env.NEXT_PUBLIC_HTTPS ? 'https' : 'http'}://localhost:3000/api/bff-proxy`,
  }),
  ...(process.env.NEXT_PUBLIC_NEW_SEARCH_BFF_ENDPOINT_URL && {
    baseURL: process.env.NEXT_PUBLIC_NEW_SEARCH_BFF_ENDPOINT_URL,
  }),
  onError: datadogRum.addError,
} as const satisfies ApiConfig;

export const SearchApiClient = new SearchApi(SEARCH_API_CONFIG);
